class MobileNavToggle extends HTMLElement {
  constructor() {
    super();
    this.menuDrawer = document.querySelector(".f-drawer-mobile-nav");
    this.onClick = () => this.openNav();
    this.addEventListener("click", this.onClick);

    this.menuDrawer?.addEventListener("close", () => {
      this.setAttribute("aria-expanded", "false");
    });
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
  }

  openNav() {
    if (this.menuDrawer) {
      this.menuDrawer.openDrawer();
      this.setAttribute("aria-expanded", "true");
    }
  }
}
customElements.define("mobile-nav-toggle", MobileNavToggle);